module.exports = __webpack_public_path__ + "img/256_Third of Brookfield_Pool_teracce_D2_cam2.b087f9b2.jpg";